import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useCookieData } from "../hook/useCookieData";
import { getCDCEnabled } from "../services/template";

interface CDCContextType {
  hasCDC: boolean;
  setHasCDC: (value: boolean) => void;
}

const CDCContext = createContext<CDCContextType | undefined>(undefined);

interface CDCProviderProps {
  children: ReactNode;
}

export const CDCProvider: React.FC<CDCProviderProps> = ({ children }) => {
  const [hasCDC, setHasCDC] = useState<boolean>(true);
  const { resolvedTenantId } = useCookieData();

  useEffect(() => {
    const currentTenantId = resolvedTenantId;
    if (currentTenantId) {
      getCDCEnabled(currentTenantId)
        .then((response) => {
          setHasCDC(response.data.data);
        })
        .catch((error) => {
          console.error("Failed to fetch CDC enabled status:", error);
          // Default to true on error
          setHasCDC(true);
        });
    }
  }, [resolvedTenantId]);

  return (
    <CDCContext.Provider value={{ hasCDC, setHasCDC }}>
      {children}
    </CDCContext.Provider>
  );
};

export const useCDCContext = (): CDCContextType => {
  const context = useContext(CDCContext);
  if (context === undefined) {
    throw new Error("useCDCContext must be used within a CDCProvider");
  }
  return context;
};

export default CDCContext;
